import React, { useState } from "react";
import TimeDifference from "../../common/TimeDifference";
import ArticleView from "./ArticleView";

function ArticleItem({ article, checkedItem, chindex, handleCheckboxChange }) {
  const handleCheckbox = (e) => handleCheckboxChange(e, article, chindex);
  const [viewArticle, setViewArticle] = useState(false);

  const handlePrint = (id) => {
    window.open(`/print-article/${id}`, "_blank");
  };

  const handleViewArticle = (article) => {
    setViewArticle(true);
  };

  return (
      <>
      <div className="card article-card modern-card mb-4">
        <div className="card-body p-4">
          <div className="d-flex gap-3 align-items-start">
            {/* Checkbox aligned with title */}
            <div className="form-check flex-shrink-0 mt-1">
              <input
                  type="checkbox"
                  className="form-check-input custom-checkbox"
                  id={`article-${article.id}`}
                  checked={checkedItem}
                  onChange={handleCheckbox}
              />
            </div>

            {/* Article Content */}
            <div className="flex-grow-1 min-width-0">
              {/* Title row with checkbox and metadata */}
              <div className="d-flex align-items-start justify-content-between mb-3">
                <div className="d-flex align-items-start gap-3 flex-grow-1 me-3">
                  <h6 className="card-title mb-0 fw-bold text-dark article-title">
                    {article.title}
                  </h6>
                </div>

                <div className="d-flex gap-2 align-items-center flex-shrink-0">
                  {/* Article Metadata */}
                  {article.date && (
                      <span className="text-muted small d-flex align-items-center gap-1">
                    <i className="bi bi-clock"></i>
                    <TimeDifference date={article.date} />
                  </span>
                  )}
                  {article.category && (
                      <span className="badge bg-light text-dark small">
                    {article.category}
                  </span>
                  )}
                </div>
              </div>

              <p className="card-text text-muted mb-3 text-break article-summary">
                {article.summary}
              </p>

              {/* Article Footer with Actions */}
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-2">
                  {article.tags && article.tags.map((tag, index) => (
                      <span key={index} className="badge bg-primary bg-opacity-10 text-primary small">
                    #{tag}
                  </span>
                  ))}
                </div>

                <div className="d-flex gap-2">
                  <button
                      className="btn btn-sm btn-outline-primary rounded-pill px-3 d-flex align-items-center gap-2"
                      onClick={() => handleViewArticle(article)}
                      title="View Article"
                  >
                    <i className="bi bi-eye-fill"></i>
                    <span className="d-none d-sm-inline">View</span>
                  </button>
                  <button
                      className="btn btn-sm btn-outline-secondary rounded-pill px-3 d-flex align-items-center gap-2"
                      onClick={() => handlePrint(article.id)}
                      title="Print Article"
                      aria-label="Print Article"
                  >
                    <i className="bi bi-printer-fill"></i>
                    <span className="d-none d-sm-inline">Print</span>
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>



        <style>{`
        .modern-card {
          border: none;
          border-radius: 16px;
          background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border-left: 4px solid transparent;
        }

        .modern-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
          border-left-color: var(--bs-primary);
        }

        .custom-checkbox {
          width: 1.25rem;
          height: 1.25rem;
          border: 2px solid #dee2e6;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          margin-top: 0.15rem;
        }

        .custom-checkbox:checked {
          background-color: var(--bs-primary);
          border-color: var(--bs-primary);
          box-shadow: 0 2px 8px rgba(var(--bs-primary-rgb), 0.3);
        }

        .custom-checkbox:focus {
          box-shadow: 0 0 0 3px rgba(var(--bs-primary-rgb), 0.1);
        }

        .article-title {
          line-height: 1.4;
          background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-top: -0.1rem;
        }

        .article-summary {
          line-height: 1.6;
          text-align: justify;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .btn {
          transition: all 0.2s ease;
          font-weight: 500;
        }

        .btn:hover {
          transform: translateY(-1px);
        }

        .badge {
          font-size: 0.7rem;
          font-weight: 500;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .fade-in {
          animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        /* Fix alignment for checkbox and title */
        .form-check {
          margin-top: 0.15rem !important;
        }

        .d-flex.align-items-start .article-title {
          padding-top: 0.1rem;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .card-body {
            padding: 1.5rem !important;
          }
          
          .d-flex.gap-3 {
            gap: 1rem !important;
          }
          
          .article-title {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 576px) {
          .d-flex.justify-content-between.align-items-center {
            flex-direction: column;
            gap: 1rem;
            align-items: flex-start;
          }
          
          .btn span {
            display: none;
          }
          
          .btn {
            padding: 0.5rem;
          }

          /* Better alignment on mobile */
          .d-flex.align-items-start.justify-content-between {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
          }
          
          .d-flex.align-items-start.justify-content-between > div:last-child {
            align-self: flex-end;
          }
        }
      `}</style>
      </div>
        {/* Modal for viewing article */}
        <ArticleView
            show={viewArticle}
            articleid={article.id}
            onClose={() => setViewArticle(false)}
        />

        </>
  );
}

export default ArticleItem;